import Script from 'next/script';

const RedVentureScript: React.FC = () => (
  <Script
    src='https://static.myfinance.com/widget/myFinance.js'
    strategy='lazyOnload'
  />
);

export { RedVentureScript };
